import { useEffect, useRef } from 'react';

const LOOP_TIMER_MS = 500;

/**
 * A watcher to look for the cookie banner element in the DOM and if it's there,
 * ensure that the 'inert' attribute is removed. Carbon dialogs will add 'inert'
 * to everything when they open, which results in the cookie banner blocking the
 * app as it stays on top but none of the controls respond!
 */
export const useCookieBannerGuard = (stayAlive = false) => {
  const bannerOpened = useRef(false);

  useEffect(() => {
    const loop = window.setInterval(() => {
      const banner = document.getElementById('onetrust-consent-sdk');
      const hasUserClosedBanner = !banner && bannerOpened.current === true;

      if (banner) {
        bannerOpened.current = true;
        banner.removeAttribute('aria-hidden');
        banner.removeAttribute('inert');
      }

      // If banner has been closed, the user cant reopen it, so kill the loop (unless stayAlive flag set)
      if (hasUserClosedBanner && !stayAlive) {
        window.clearInterval(loop);
      }
    }, LOOP_TIMER_MS);

    return () => {
      window.clearInterval(loop);
    };
  }, [stayAlive]);
};
